import { render, staticRenderFns } from "./StructuredData.vue?vue&type=template&id=d7f16368&scoped=true&"
import script from "./StructuredData.vue?vue&type=script&lang=js&"
export * from "./StructuredData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7f16368",
  null
  
)

export default component.exports